import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=3f5315a4&"
import script from "./CalendarView.vue?vue&type=script&lang=ts&"
export * from "./CalendarView.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=3f5315a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports